export default "__VITE_ASSET__DmUlK5Jt__"